import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, forwardRef, useContext } from 'react';
import { LABEL } from '../../../constants';
import { useInput } from '../../../hooks';
import { Context } from '../Context';
const Label = forwardRef(({ children, render, ...rest }, ref) => {
    const context = useContext(Context);
    const { isInvalid, isLoading, isRequired } = context;
    const { labelProps } = useInput(context);
    return (_jsx("label", { ref: ref, ...labelProps, ...rest, children: render ? (render({ isInvalid, isLoading, isRequired })) : isRequired ? (_jsxs(Fragment, { children: [children, _jsx("span", { "aria-hidden": true, children: " *" })] })) : (children) }));
});
Label.displayName = LABEL;
export { Label };
//# sourceMappingURL=Label.js.map